import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PaginationComponent } from 'src/app/components/shared/pagination/pagination.component';
import { SearchFilterComponent } from 'src/app/components/shared/search-filter/search-filter.component';
import { CertificationsService } from 'src/app/services/certifications.service';
import { CertificationsModalComponent } from './certifications-modal/certifications-modal.component';


@Component({
  selector: 'app-certifications',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './certifications.component.html',
  styleUrls: ['./certifications.component.css']
})
export class CertificationsComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private CertificationsService: CertificationsService,
      private cdr: ChangeDetectorRef
  ) {} 

  
  CertificationsList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getCertifications();
  }

  getCertifications(){
    this.CertificationsService.getCertifications().subscribe({
      next: (res: any) => {
        this.CertificationsList = res;
        this.filteredData = [...this.CertificationsList];
        this.cdr.detectChanges();
      }});
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(CertificationsModalComponent, {
      data: { item, mode, title }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getCertifications();
        }
      }
    });
  }

}
